  export const gradeColors = {
    1: "rgba(255, 11, 11, 1)",
    2: "rgba(255, 11, 11, 0.85)",
    3: "rgba(255, 11, 11, 0.5)",
    4: "rgba(255, 11, 11, 0.3)",
    5: "rgba(255, 151, 11, 0.4)",
    6: "rgba(255, 151, 11, 0.3)",
    7: "rgba(11, 255, 11, 0.3)",
    8: "rgba(11, 255, 11, 0.5)",
    9: "rgba(11, 255, 11, 0.75)",
    10: "rgba(11, 255, 11, 1)"
  };
